import React from 'react'
import * as Utils from 'Assets/Utils'

import Immutable from 'immutable'
import ClientHttpRequest from "Api/ClientHttpRequest"
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({}).set('Get', new Immutable.Map({}))

/* Types */
export const GET_SUSTAINABLE_GOALS = 'GET_SUSTAINABLE_GOALS'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_SUSTAINABLE_GOALS:
			return state.set('Get', new Immutable.Map(action.Obj))
		default:
			return state;
	}
}

/* Action Creators */
export const setSustainableGoals = (form) => {

	let originalObj = Object.assign({}, form.original)
	originalObj.preguntaObjetivosCorrectos.respuesta = form.objetivosRadio === 1 ? true : false
	originalObj.preguntaObjetivosCorrectos.observaciones = form.objetivos

	const objetivos = form.objEjecutivo

	const metasArr = (idObjetivo) => {
		const objetivo = Utils.getItem(objetivos, { id: idObjetivo })
		return objetivo.metas.map(m => m.meta.id)
	}

	const indicadoresArr = (idObjetivo, param) => {
		const objetivo = Utils.getItem(objetivos, { id: idObjetivo })
		return objetivo.metas.map(m => m[param])
	}
	
	if (form.objetivosRadio === 2) {

		const preguntasRespuestas = [
			{
				indice: 1,
				respuestas: [objetivos[0].objetivo.idObjetivo]
			},
			{
				indice: 2,
				respuestas: metasArr(objetivos[0].objetivo.idObjetivo)
			},
			{
				indice: 3,
				respuestas: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresCobertura')
			},
			{
				indice: 4,
				respuestas: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresCoberturaMetas')
			},
			{
				indice: 5,
				respuestas: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresResultados').map(i => {
					if (!i) {
						i = "0"
					}
					return i
				})
			},
			{
				indice: 6,
				respuestas: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresResultadosMetas').map(i => {
					if (!i) {
						i = "0"
					}
					return i
				})
			},
			{
				indice: 7,
				respuestas: objetivos.length > 1 ? [objetivos[1].objetivo.idObjetivo] : ['']
			},
			{
				indice: 8,
				respuestas: objetivos.length > 1 ? metasArr(objetivos[1].objetivo.idObjetivo) : ['', '']
			},
			{
				indice: 9,
				respuestas: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresCobertura') : ['', '']
			},
			{
				indice: 10,
				respuestas: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresCoberturaMetas') : ['', '']
			},
			{
				indice: 11,
				respuestas: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresResultados').map(i => {
					if (!i) {
						i = "0"
					}
					return i
				}) : ['', '']
			},
			{
				indice: 12,
				respuestas: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresResultadosMetas').map(i => {
					if (!i) {
						i = "0"
					}
					return i
				}) : ['', '']
			}
		]
		originalObj.objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas = preguntasRespuestas
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/setSustainableGoals',
			method: "POST",
			data: {...originalObj},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const getSustainableGoals = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getSustainableGoals',
			method: "POST",
			data: { ...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))

			const data = response.data
			const objetivosDesarrolloSostenibleDonataria = data.objetivosDesarrolloSostenibleDonataria || null
			const objetivosDesarrolloSostenibleEjecutivo = data.objetivosDesarrolloSostenibleEjecutivo

			let form = Object.assign({}, {uniqueId: Utils.getUUID()})
			let objDonataria = []
			let objEjecutivo = []

			form = {
				...form,
				objetivosRadio: data.preguntaObjetivosCorrectos && data.preguntaObjetivosCorrectos.respuesta === true ? 1 :
					data.preguntaObjetivosCorrectos && data.preguntaObjetivosCorrectos.respuesta === false ? 2 :
						data.preguntaObjetivosCorrectos && data.preguntaObjetivosCorrectos.respuesta === "true" ? 1 :
							data.preguntaObjetivosCorrectos && data.preguntaObjetivosCorrectos.respuesta === "false" ? 2 : 1,
				objetivos: data.preguntaObjetivosCorrectos ? data.preguntaObjetivosCorrectos.observaciones : '',
			}

			if (objetivosDesarrolloSostenibleDonataria) {

				if (objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[0] && (objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[0].respuestas && objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[0].respuestas[0])) {

					let objetivo = objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.filter(i =>  i.objetivoDesarrollo.id === parseInt(objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[0].respuestas)) ? objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.filter(i =>  i.objetivoDesarrollo.id === parseInt(objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[0].respuestas)) : []
					
					if (objetivo[0]) {

						let objetivoObj = {id: objetivo[0].objetivoDesarrollo.id, objetivo:{idObjetivo: objetivo[0].objetivoDesarrollo.id, descripcion: objetivo[0].objetivoDesarrollo.descripcion, metas: objetivo[0].objetivoDesarrollo.metaObjetivo}}
						let metas = []

						if (objetivo[0].objetivoDesarrollo.metaObjetivo) {
							objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[1].respuestas.forEach((m, indexMeta) => {
								
								let meta = Utils.getItem(objetivo[0].objetivoDesarrollo.metaObjetivo, {id: parseInt(m)})
									
									if (meta) {
			
										let metaObj = { idObjetivo: objetivo[0].objetivoDesarrollo.id, idMeta: meta.id, meta }
								
										let idIndicadoresCobertura = objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[2].respuestas[indexMeta === 0 ? 0 : 1] !== "0" ?
												objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[2].respuestas[indexMeta === 0 ? 0 : 1] : ""
										let idIndicadoresCoberturaMetas = objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[3].respuestas[indexMeta === 0 ? 0 : 1]
			
										let idIndicadoresResultados = objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[4].respuestas[indexMeta === 0 ? 0 : 1] !== "0" ?
												objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[4].respuestas[indexMeta === 0 ? 0 : 1] : ""
										let idIndicadoresResultadosMetas = objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[5].respuestas[indexMeta === 0 ? 0 : 1]
			
										const IndicadoresCobertura = () => {
											const iteratorList = idIndicadoresCobertura ? idIndicadoresCobertura.split(",") : []
											const indicatorsList = iteratorList.map((i, index) => {
			
												let { descripcion } = Utils.getItem(meta.indicador, { id: parseInt(i) })
												let metaItem = idIndicadoresCoberturaMetas.split(",")
			
												return (
													<li key={descripcion.toString()}>
														<p>
															{descripcion}
															<br />
															<small>{`Meta institución: ${metaItem[index]}`}</small>
														</p>
													</li>
												)
											})
											return (
												<ul className="indicadores-question">
													{indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'}
												</ul>
											)
										}
			
									let IndicadoresResultados = () => {
										const iteratorList = idIndicadoresResultados ? idIndicadoresResultados.split(",") : []
										const indicatorsList = iteratorList.map((i, index) => {
												let { descripcion } = Utils.getItem(meta.indicador, { id: parseInt(i) })
												let metaItem = idIndicadoresResultadosMetas.split(",")
													return (
														<li key={descripcion.toString()}>
															<p>
																{descripcion}
																<br />
																<small>{`Meta institución: ${metaItem[index]}`}</small>
															</p>
														</li>
													)
											})
											return (
												<ul className="indicadores-question">
													{indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'}
												</ul>
												)
											}
			
									metaObj = {
										...metaObj,
										idObjetivo: objetivo[0].objetivoDesarrollo.id,
										idIndicadoresCobertura,
										idIndicadoresResultados,
										idIndicadoresCoberturaMetas,
										idIndicadoresResultadosMetas,
										indicadoresCobertura: <IndicadoresCobertura />,
										indicadoresResultados: <IndicadoresResultados />
									}
									metas.push(metaObj)
								}
							})
							objetivoObj = {...objetivoObj, metas}
							objDonataria.push(objetivoObj)
						}
					}
				}
	
				if (objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[6] && (objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[6].respuestas && objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[6].respuestas[0])) {
	
					let objetivo = objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.filter(i =>  i.objetivoDesarrollo.id === parseInt(objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[6].respuestas)) ? objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.filter(i =>  i.objetivoDesarrollo.id === parseInt(objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[6].respuestas)): []
					
					if (objetivo[0]) {
						
						let objetivoObj = {id: objetivo[0].objetivoDesarrollo.id, objetivo:{idObjetivo: objetivo[0].objetivoDesarrollo.id, descripcion: objetivo[0].objetivoDesarrollo.descripcion, metas: objetivo[0].objetivoDesarrollo.metaObjetivo}}
						let metas = []
	
						if (objetivo[0].objetivoDesarrollo.metaObjetivo) {
							objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[7].respuestas.forEach((m, indexMeta) => {
								
								let meta = Utils.getItem(objetivo[0].objetivoDesarrollo.metaObjetivo, {id: parseInt(m)})
								
								if (meta) {
		
									let metaObj = { idObjetivo: objetivo[0].objetivoDesarrollo.id, idMeta: meta.id, meta }
		
									let idIndicadoresCobertura = objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[8].respuestas[indexMeta === 0 ? 0 : 1] !== "0" ?
											objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[8].respuestas[indexMeta === 0 ? 0 : 1] : ""
									let idIndicadoresCoberturaMetas = objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[9].respuestas[indexMeta === 0 ? 0 : 1]
		
									let idIndicadoresResultados = objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[10].respuestas[indexMeta === 0 ? 0 : 1] !== "0" ?
											objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[10].respuestas[indexMeta === 0 ? 0 : 1] : ""
									let idIndicadoresResultadosMetas = objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[11].respuestas[indexMeta === 0 ? 0 : 1]
		
									const IndicadoresCobertura = () => {
										const iteratorList = idIndicadoresCobertura ? idIndicadoresCobertura.split(",") : []
										const indicatorsList = iteratorList.map((i, index) => {
		
											let { descripcion } = Utils.getItem(meta.indicador, { id: parseInt(i) })
											let metaItem = idIndicadoresCoberturaMetas.split(",")
		
											return (
												<li key={descripcion.toString()}>
													<p>
														{descripcion}
														<br />
														<small>{`Meta institución: ${metaItem[index]}`}</small>
													</p>
												</li>
											)
										})
										return (
											<ul className="indicadores-question">
												{indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'}
											</ul>
										)
									}
		
								let IndicadoresResultados = () => {
									const iteratorList = idIndicadoresResultados ? idIndicadoresResultados.split(",") : []
									const indicatorsList = iteratorList.map((i, index) => {
		
										let { descripcion } = Utils.getItem(meta.indicador, { id: parseInt(i) })
										let metaItem = idIndicadoresResultadosMetas.split(",")
		
										return (
											<li key={descripcion.toString()}>
												<p>
													{descripcion}
													<br />
													<small>{`Meta institución: ${metaItem[index]}`}</small>
												</p>
											</li>
										)
									})
									return (
										<ul className="indicadores-question">
											{indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'}
										</ul>
									)
								}
		
								metaObj = {
									...metaObj,
									idObjetivo: objetivo[0].objetivoDesarrollo.id,
									idIndicadoresCobertura,
									idIndicadoresResultados,
									idIndicadoresCoberturaMetas,
									idIndicadoresResultadosMetas,
									indicadoresCobertura: <IndicadoresCobertura />,
									indicadoresResultados: <IndicadoresResultados />
								}
								metas.push(metaObj)
							}
						})
						objetivoObj = {...objetivoObj, metas}
						objDonataria.push(objetivoObj)
						}
					}
				}
			}

			form = {
				...form,
				objDonataria,
				objEjecutivo
			}

			if (objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[0] && (objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[0].respuestas && objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[0].respuestas[0])) {

				let objetivo = objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.filter(i =>  i.objetivoDesarrollo.id === parseInt(objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[0].respuestas)) ? objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.filter(i =>  i.objetivoDesarrollo.id === parseInt(objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[0].respuestas)): []
				
				if (objetivo[0]) {

					let objetivoObj = {id: objetivo[0].objetivoDesarrollo.id, objetivo:{idObjetivo: objetivo[0].objetivoDesarrollo.id, descripcion: objetivo[0].objetivoDesarrollo.descripcion}}
					let metas = []
	
					if (objetivo[0].objetivoDesarrollo.metaObjetivo) {
						objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[1].respuestas.forEach((m, indexMeta) => {
							
							let meta = Utils.getItem(objetivo[0].objetivoDesarrollo.metaObjetivo, {id: parseInt(m)})
							
							if (meta) {
	
								let metaObj = { idObjetivo: objetivo[0].objetivoDesarrollo.id, idMeta: meta.id, meta }
								let idIndicadoresCobertura = objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[2].respuestas[indexMeta === 0 ? 0 : 1] !== "0" ?
										objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[2].respuestas[indexMeta === 0 ? 0 : 1] : ""
								let idIndicadoresCoberturaMetas = objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[3].respuestas[indexMeta === 0 ? 0 : 1]
	
								let idIndicadoresResultados = objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[4].respuestas[indexMeta === 0 ? 0 : 1] !== "0" ?
										objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[4].respuestas[indexMeta === 0 ? 0 : 1] : ""
								let idIndicadoresResultadosMetas = objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[5].respuestas[indexMeta === 0 ? 0 : 1]
	
								const IndicadoresCobertura = () => {
									const iteratorList = idIndicadoresCobertura ? idIndicadoresCobertura.split(",") : []
									const indicatorsList = iteratorList.map((i, index) => {
	
										let { descripcion } = Utils.getItem(meta.indicador, { id: parseInt(i) })
										let metaItem = idIndicadoresCoberturaMetas.split(",")
	
										return (
											<li key={descripcion.toString()}>
												<p>
													{descripcion}
													<br />
													<small>{`Meta institución: ${metaItem[index]}`}</small>
												</p>
											</li>
										)
									})
									return (
										<ul className="indicadores-question">
											{indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'}
										</ul>
									)
								}
	
								let IndicadoresResultados = () => {
									const iteratorList = idIndicadoresResultados ? idIndicadoresResultados.split(",") : []
									const indicatorsList = iteratorList.map((i, index) => {
	
										let { descripcion } = Utils.getItem(meta.indicador, { id: parseInt(i) })
										let metaItem = idIndicadoresResultadosMetas.split(",")
	
										return (
											<li key={descripcion.toString()}>
												<p>
													{descripcion}
													<br />
													<small>{`Meta institución: ${metaItem[index]}`}</small>
												</p>
											</li>
										)
									})
									return (
										<ul className="indicadores-question">
											{indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'}
										</ul>
									)
								}
	
							metaObj = {
								...metaObj,
								idObjetivo: objetivo[0].objetivoDesarrollo.id,
								idIndicadoresCobertura,
								idIndicadoresResultados,
								idIndicadoresCoberturaMetas,
								idIndicadoresResultadosMetas,
								indicadoresCobertura: <IndicadoresCobertura />,
								indicadoresResultados: <IndicadoresResultados />
							}
							metas.push(metaObj)
						}
					})
					objetivoObj = {...objetivoObj, metas}
					objEjecutivo.push(objetivoObj)
					}
				}
			}

			if (objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[6] && (objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[6].respuestas && objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[6].respuestas[0])) {

				let objetivo = objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.filter(i =>  i.objetivoDesarrollo.id === parseInt(objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[6].respuestas)) ? objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.filter(i =>  i.objetivoDesarrollo.id === parseInt(objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[6].respuestas)): []
				
				if (objetivo[0]) {
					let objetivoObj = {id: objetivo[0].objetivoDesarrollo.id, objetivo:{idObjetivo: objetivo[0].objetivoDesarrollo.id, descripcion: objetivo[0].objetivoDesarrollo.descripcion}}
					let metas = []
	
					if (objetivo[0].objetivoDesarrollo.metaObjetivo) {
										objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[7].respuestas.forEach((m, indexMeta) => {
							
							let meta = Utils.getItem(objetivo[0].objetivoDesarrollo.metaObjetivo, {id: parseInt(m)})
							
							if (meta) {
	
								let metaObj = { idObjetivo: objetivo[0].objetivoDesarrollo.id, idMeta: meta.id, meta }
	
								let idIndicadoresCobertura = objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[8].respuestas[indexMeta === 0 ? 0 : 1] !== "0" ?
										objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[8].respuestas[indexMeta === 0 ? 0 : 1] : ""
								let idIndicadoresCoberturaMetas = objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[9].respuestas[indexMeta === 0 ? 0 : 1]
	
								let idIndicadoresResultados = objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[10].respuestas[indexMeta === 0 ? 0 : 1] !== "0" ?
										objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[10].respuestas[indexMeta === 0 ? 0 : 1] : ""
								let idIndicadoresResultadosMetas = objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[11].respuestas[indexMeta === 0 ? 0 : 1]
	
								const IndicadoresCobertura = () => {
									const iteratorList = idIndicadoresCobertura ? idIndicadoresCobertura.split(",") : []
									const indicatorsList = iteratorList.map((i, index) => {
	
										let { descripcion } = Utils.getItem(meta.indicador, { id: parseInt(i) })
										let metaItem = idIndicadoresCoberturaMetas.split(",")
	
										return (
											<li key={descripcion.toString()}>
												<p>
													{descripcion}
													<br />
													<small>{`Meta institución: ${metaItem[index]}`}</small>
												</p>
											</li>
										)
									})
									return (
										<ul className="indicadores-question">
											{indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'}
										</ul>
									)
								}
	
								let IndicadoresResultados = () => {
									const iteratorList = idIndicadoresResultados ? idIndicadoresResultados.split(",") : []
									const indicatorsList = iteratorList.map((i, index) => {
	
										let { descripcion } = Utils.getItem(meta.indicador, { id: parseInt(i) })
										let metaItem = idIndicadoresResultadosMetas.split(",")
	
										return (
											<li key={descripcion.toString()}>
												<p>
													{descripcion}
													<br />
													<small>{`Meta institución: ${metaItem[index]}`}</small>
												</p>
											</li>
										)
									})
									return (
										<ul className="indicadores-question">
											{indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'}
										</ul>
									)
								}
	
							metaObj = {
								...metaObj,
								idObjetivo: objetivo[0].objetivoDesarrollo.id,
								idIndicadoresCobertura,
								idIndicadoresResultados,
								idIndicadoresCoberturaMetas,
								idIndicadoresResultadosMetas,
								indicadoresCobertura: <IndicadoresCobertura />,
								indicadoresResultados: <IndicadoresResultados />
							}
							metas.push(metaObj)
						}
					})
					objetivoObj = {...objetivoObj, metas}
					objEjecutivo.push(objetivoObj)
					}
				}
			}

			form = {
				...form,
				objDonataria,
				objEjecutivo
			}

			let objetivosDesarrollo = []

			if (objetivosDesarrolloSostenibleDonataria) {

				objetivosDesarrollo = objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.map((o) => {
					return {
						id: o.objetivoDesarrollo.id,
						descripcion: o.objetivoDesarrollo.descripcion,
						metaObjetivo: o.objetivoDesarrollo.metaObjetivo
					}
				})
			}

			form = {
				...form, 
				objetivosDesarrolloSostenibleDonataria, 
				objetivosDesarrolloSostenibleEjecutivo, 
				objetivosDesarrollo, 
				original: data,
				disabledAll: data.preguntaObjetivosCorrectos.respuesta,
				editODS: form.objetivosRadio === 1 ? false : form.objetivosRadio === 2 ? true : false
			}

			dispatch({ type: GET_SUSTAINABLE_GOALS, Obj: form  })
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}



// WEBPACK FOOTER //
// ./src/modules/Grantees/Evaluation/SustainableGoals.js